import React from 'react';

import Layout from '../../Layout/index';
import NewsList from '../../NewsList/index';


const Science = () => {
    return (
        <Layout title="Science News - Bull & Bear">
            <NewsList category="science" />
        </Layout>
    )
};

export default Science;